export const MODELS_TABLE_CONTROLLER = 'models';
export const MODELS_TABLE_ID = 'models_table';



// WEBPACK FOOTER //
// ./webpack/assets/javascripts/react_app/components/ModelsTable/ModelsTableConstants.js